import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';

@Component({
  selector: 'app-input-price',
  templateUrl: './input-price.component.html',
  styleUrls: ['./input-price.component.less']
})
export class InputPriceComponent extends Field {

  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterPrice(value: number): string {
    if (value === null || isNaN(value)) {
      return '';
    }

    if (this.currencyField !== undefined) {
      console.log(this.currencyField.Value);
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.PriceDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
